import { render, staticRenderFns } from "./PcHome.vue?vue&type=template&id=aad10974&scoped=true"
import script from "./PcHome.vue?vue&type=script&lang=js"
export * from "./PcHome.vue?vue&type=script&lang=js"
import style0 from "./PcHome.vue?vue&type=style&index=0&id=aad10974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad10974",
  null
  
)

export default component.exports